import { ComponentProps } from 'react'
import styled from 'styled-components'

import { breakpoints, media } from 'styles/media'

import LazyImage from '../../components/display/LazyImage'

import { zIndex as navbarZIndex } from '../../layout/Navbar/constants'

export const Outer = styled.div`
  z-index: ${navbarZIndex - 1};
  position: relative;

  height: 0;
  width: 100%;

  padding-top: 160%;

  ${media.md`
    padding-top: 40%;
  `}

  background-color: ${({ theme }) => theme?.['-ds-core-300']?.value};

  ${LazyImage} {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`

export const Inner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;

  color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  text-align: center;
  padding: 0 16px;
`

export const ActionWrapper = styled.div`
  z-index: 10;

  button,
  a {
    width: fit-content;
    margin: 24px auto;
    color: white;
    border-color: white;
    background-color: transparent;
  }
`

export const Title = styled.h1`
  font-size: 50px;
  letter-spacing: 0.25px;
  font-weight: 500;
  z-index: 10;
`

export const SmallTitle = styled.h1`
  text-transform: uppercase;
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};
  font-weight: 400;
  line-height: 1.3;
  margin-bottom: 16px;
`

export const Subtitle = styled.h2`
  font-size: 36px;
  letter-spacing: 0.25px;
  font-weight: 500;
  z-index: 10;
`

export const LargeSubtitle = styled.h2`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xl']?.['font-size']?.value};
  font-weight: 400;
  line-height: 1.2;
  max-width: 933px;
  margin: 0 auto;

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-size']?.value};
  `}

  ${media.lg`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxxl']?.['font-size']?.value};
  `}
`

type ArtDirectionImageProps = ComponentProps<typeof LazyImage> & {
  mobileImageSrcset: string
  desktopImageSrcset: string
  fallbackSrc: string
}

export const ArtDirectionImage = (props: ArtDirectionImageProps) => {
  const { mobileImageSrcset, desktopImageSrcset, fallbackSrc, ...rest } = props

  return (
    <picture>
      <source
        media={`(max-width: ${breakpoints.md}px)`}
        data-srcset={mobileImageSrcset}
      />
      <source
        media={`(min-width: ${breakpoints.md}px)`}
        data-srcset={desktopImageSrcset}
      />
      <LazyImage data-src={fallbackSrc} {...rest} />
    </picture>
  )
}
